import React, { createContext, useReducer, useContext } from 'react';

// 定义初始状态和操作
const initialState = {
  init: true,
  project_name:'loading...',
  technical_support_company:'loading...',
};

const reducer = (state, action) => {
  switch (action.type) {
    case 'SET_GLOBAL_VARIABLE':
      return {init:false, ...state, ...action.payload };
    default:
      return state;
  }
};

const GlobalStateContext = createContext();

export const GlobalStateProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState);

  return (
    <GlobalStateContext.Provider value={{ state, dispatch }}>
      {children}
    </GlobalStateContext.Provider>
  );
};

export const useGlobalState = () => {
  const context = useContext(GlobalStateContext);
  if (!context) {
    throw new Error('useGlobalState must be used within a GlobalStateProvider');
  }
  return context;
};
